import Specified from "components/Specified";

export default Specified;



// WEBPACK FOOTER //
// ./src/containers/Specified/index.js